import backend from '@/modules/Backend'
import sortBy from 'lodash/sortBy'
import keyBy from 'lodash/keyBy'
import dateUtils from '@/modules/dateUtils'

export const STORAGE_KEY = 'springleaf-storage'

const state = {
  wuid: null,
  authenticated: false,
  user: null,
  profile: null,
  loaded: [],
  weekDate: dateUtils.getWeekDate(),
  weekDay: dateUtils.getWeekDay(),
  todoHomeworks: [],
  dayCourses: [],
  allCourses: [],
  weekSchedules: {},
  daySchedules: {}
}

const getters = {
  keyedCourses: state => keyBy(state.allCourses, 'id')
}

const mutations = {
  setWuid (state, wuid) {
    state.wuid = wuid
  },
  setAuthenticated (state, authenticated) {
    state.authenticated = authenticated
  },
  setUser (state, user) {
    state.user = user
  },
  setProfile (state, profile) {
    state.profile = profile
  },
  setLoaded (state, loaded) {
    state.loaded = loaded
  },
  addLoaded (state, name) {
    state.loaded.push(name)
  },
  resetLoaded (state, name) {
    state.loaded = []
  },
  setTodoHomeworks (state, todoHomeworks) {
    state.todoHomeworks = todoHomeworks
  },
  setAllCourses (state, allCourses) {
    state.allCourses = allCourses
  },
  setWeekSchedules (state, weekSchedules) {
    state.weekSchedules = weekSchedules
  }
}

// Async to fetch data
const actions = {

  async refreshAuthStatus ({commit}) {
    const {profile, user} = (await backend.authStatus()).data
    commit('setProfile', profile)
    commit('setUser', user)
  },

  load ({commit}, data) {
    const toLoad = data.filter(name => !state.loaded.includes(name))
    return Promise.all(toLoad.map(name =>
      actionMap[name]().then(data => { commit(toActionName(name), data) })
    )).then(() => {
      toLoad.forEach(name => {
        commit('addLoaded', name)
      })
    })
  },

  resetLoaded ({commit}) {
    commit('resetLoaded')
  }
}

const actionMap = {
  async todoHomeworks () {
    return sortBy(await backend.fetchHomework('me', '', 'todo'), 'due_date')
  },
  async allCourses () {
    return await backend.fetchAllCourses()
  },
  async weekSchedules () {
    return await backend.fetchWeekSchedules()
  }
}

function toActionName (string) {
  return 'set' + string.charAt(0).toUpperCase() + string.slice(1)
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/store.js